import { useSnapshot } from 'valtio'
import { windowSizeState } from './utils/windowSize'

import Homepage from './pages/Homepage'
import { useEffect } from 'react'
import uiState from './data'

function App() {
  return (
    <div className='App select-none tracking-[2px] overscroll-none '>
      <Homepage event='homepage' />
    </div>
  )
}

export default App
